export default __webpack_public_path__ + "static/media/arrow.77a4f6fa.svg";